module.exports = __webpack_public_path__ + "img/bingo_ball-2.b3e6d84f.png";